"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentHumidity = exports.HumidityFactor = void 0;
var uom_1 = require("uom");
exports.HumidityFactor = uom_1.Unit.createBase("HumidityFactor", "RelativeHumidity", "r.H.");
/** Factor of humidity, eg., 0.01 means 1% */
exports.PercentHumidity = uom_1.Unit.divideNumber("PercentHumidity", 100.0, exports.HumidityFactor);
//# sourceMappingURL=relative-humidity.js.map